
<template>
<div>
  <div style="background-size:cover" class="c-app flex-row align-items-center" :style="{ backgroundImage: `url(${backgroundUrlTemplate})` }">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup class="custom-card-login">
            <CCard class="p-3 bg-custom d-md-down-none" :style="{ backgroundImage: `url(${backgroundUrl})` }">
              <!-- <h3 class="text-center mb-2"><strong>ONLINE TUTORING SESSION</strong></h3> -->
            </CCard>
            <CCard
              color="default"
              text-color="white"
              class="text-center"
              body-wrapper
            >
              <CCardBody>
                  <CTabs add-tab-classes="mt-1">
                    <CTab>
                      <template slot="title">Sign Up</template>
                      <CForm>
                        <p class="text-dark mt-4">Register your account</p>
                        <CInput placeholder="FullName">
                          <template #prepend-content>
                            <CIcon name="cil-user" />
                          </template>
                        </CInput>
                        <CInput placeholder="Email" autocomplete="email">
                          <template #prepend-content>
                            <CIcon name="cil-user" />
                          </template>
                        </CInput>
                        <CInput
                          placeholder="Password"
                          type="password"
                          autocomplete="curent-password"
                        >
                          <template #prepend-content>
                            <CIcon name="cil-lock-locked" />
                          </template>
                        </CInput>
                        <CRow>
                          <CCol col="12" class="text-left">
                            <CButton block color="success">Sign Up</CButton>
                          </CCol>
                          <!-- <CCol col="12" class="text-center">
                            <CButton color="link" class="px-0">Already have Account ?</CButton>
                          </CCol> -->
                        </CRow>
                      </CForm>
                    </CTab>
                    <CTab active>
                      <template slot="title">Sign In</template>
                      <CForm>
                        <p class="text-dark mt-4">Sign In to your account</p>
                        <CInput placeholder="Username" autocomplete="username email">
                          <template #prepend-content>
                            <CIcon name="cil-user" />
                          </template>
                        </CInput>
                        <CInput
                          placeholder="Password"
                          type="password"
                          autocomplete="curent-password"
                        >
                          <template #prepend-content>
                            <CIcon name="cil-lock-locked" />
                          </template>
                        </CInput>
                        <CRow>
                          <CCol col="12" class="text-left">
                            <CButton block color="primary">Login</CButton>
                          </CCol>
                          <CCol col="12" class="text-center">
                            <CButton color="link" class="px-0">Forgot Password ?</CButton>
                          </CCol>
                        </CRow>
                      </CForm>
                    </CTab>
                  </CTabs>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
  </div>
</template>

<script>
import backgroundUrl from "../assets/img/bgLogin.png";
import backgroundUrlTemplate from "../assets/img/bg.png";
export default {
  name: "Login",
  data() {
    return {
      backgroundUrl,
      backgroundUrlTemplate,
    };
  },
};
</script>
